import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiLoader } from 'react-icons/fi';

const Loader = ({ message = "Curating your daily briefing..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="relative">
        <SafeIcon icon={FiLoader} className="text-5xl text-[#FF0000] animate-spin mb-6" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-2 h-2 bg-black rounded-full"></div>
        </div>
      </div>
      <p className="text-black font-black uppercase tracking-[0.2em] text-xs animate-pulse">{message}</p>
      <p className="text-gray-400 text-[10px] mt-2">Dr. Lionel Maten | HigherEd Daily</p>
    </div>
  );
};

export default Loader;